import React, { useRef, useState, useEffect } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import Moment from 'react-moment';
import 'moment/locale/es';
import moment from 'moment';
import { API } from "aws-amplify";
import Cookie from 'js-cookie';
import { Container, Row, Col, Button, Alert, Badge } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Form } from "react-bootstrap/";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode, faCheckCircle, faTimesCircle, faSpinner, faExclamationTriangle, faTicketAlt } from '@fortawesome/free-solid-svg-icons'
import Linkify from 'react-linkify';
import ReactHtmlParser from 'react-html-parser'; 
import QrScanner from 'components/QrScanner';
import AdmissionControl from 'components/AdmissionScanner';


import LoaderButton from "../components/LoaderButton";
import { onError, Notification } from "../libs/errorLib";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { renderCountryOptions } from "../libs/formsLib";
import config from '../config';

import "../../node_modules/noty/lib/noty.css";
import "../../node_modules/noty/lib/themes/bootstrap-v4.css";
import "./Show.css";

export default function ShowAdmissionScanner(props) {
    
  //const file = useRef(null);
  const { id } = useParams();
  const history = useHistory();
  const {isAuthenticated, getSession } = useAppContext();
  const [session, setSession] = useState(null);
  const [admin, setAdmin] = useState(false);
  const [show, setShow] = useState(null);
  const [tickets, setTickets] = useState(null); 
  const [showIsActive, setShowIsActive] = useState(false);
  const [ticket, setTicket] = useState(null);

  const [codes, setCodes] = useState([]);
  const [isLoading, setIsLoading] = useState(false); 
  const [showTicket, setShowTicket] = useState(null);
  const [showAdmission, setShowAdmission] = useState(false) 
  
  const [status, setStatus] = useState('loading');

  const [fields, handleFieldChange, resetFields] = useFormFields({    
    selectedTicket: "none",
  });
  
  const linkifyComponentDecorator = (href, text, key) => (
    <a href={href} key={key} target="_blank">
        {text}
    </a>
    );

    useEffect(() => {

    // const searchParams = new URLSearchParams(location.search);
    // if (searchParams.get('activated') == "1") {
    //     Notification('success','Tu boleto ha sido activado exitosamente')
    // }

    async function onLoad() {
        try {           
            setIsLoading(true)
            let sess = getSession()
            setSession(sess)
            
            const show = await loadShow();
            setShowIsActive(['ACTIVE','STARTED','LIVE','REPLAY','SOLD OUT','TEST'].includes(show.status))
            await loadShowTickets(show)

            let allowed = false
            if (sess.user.roles.includes('Admin')) {
                allowed = true
                setAdmin(true)
            } else {
                const producer = sess.producers.find(p => p._id == show.producer)
                if (producer) {
                    allowed = true
                }
                // if (sess.producers.contains(show.producer))
            }
            if (allowed) {
                setShow(show)
            } else {
                history.push('/')
            }            

        } catch (e) {
            onError(e);
        } finally {
            setIsLoading(false)
        }
    }

    onLoad();
    }, [id]);

    /* API CALLS  */

    async function loadShow() {
        return API.get("vivelo", `/shows/${id}`);
    }

    async function loadShowTickets(show) {
        // const courtesiesFilter = props.courtesies ? '&courtesy=1' : ''
        // const paymentFilter = props.courtesies ? '' : '&paymentType=PREPAID'
        const courtesiesFilter = ''
        const paymentFilter = ''

        const tickets = await API.get("vivelo", `/shows/${show._id}/tickets?${courtesiesFilter}${paymentFilter}`);
        if (tickets && tickets.items && tickets.items.length > 0) {
            tickets.items.forEach(t => { t.selected = 0 })
            setTickets(tickets.items)
        }
        return tickets
    }

    function renderTickets() {
        const options = []
        const ticketButtons = tickets
            .filter(t => ['VENUE_OPEN','VENUE_CLOSED'].includes(t.type))
            .map(t => {
                return <div className="show-ticket" onClick={() => { setShowTicket(t._id) } } >
                    <FontAwesomeIcon icon={faTicketAlt} className="icon" /> 
                    <span className="name">{t.fullname}</span>
                </div>
            })
        return <div className="show-admission-ticket-list">
            {ticketButtons}
        </div>
        
    }

    function exitScanner() {
        setShowTicket(null)
    }

    function renderAdmissionScanner() {
        return show && tickets && <div className="scanner-container">
            <h1>Admisión por QR</h1>
            <div>Selecciona el tipo de boleto y escanea el QR con la cámara para validar y registrar el acceso</div>
            <div>
                {renderTickets()}
            </div>
            
            {showTicket && (
                <AdmissionControl 
                    show={show}
                    showTicket={tickets.find(t => t._id == showTicket)}
                    onClose={exitScanner}
                />
            )}
        </div>
    }
    
    return (        
        !isLoading && show ? <>
        <Container fluid className="Show content content-dark">
            <div className="show-header">
                <div>
                    <div><h1>{show.fullname}</h1></div>
                    <div className="show-date"><Moment local format="ddd, LL - LT">{new Date(show.show_date)}</Moment></div>
                </div>
                <div className="show-actions">
                    <a href={`/shows/${id}/`} ><Button variant="outline-light">Info</Button></a>
                    <a href={`/shows/${id}/admission/list`} ><Button variant="outline-light">Admisión Listado</Button></a>
                    {/* <a href={`/shows/${id}/registration`} ><Button variant="outline-light">Registro</Button></a> */}
                </div>
            </div>
            <div>
                {renderAdmissionScanner()}
            </div>
        </Container>
        </> : null
    );
}